import { paginationPageSize } from './consts';

export default function (editor, opts = {}) {
  const bm = editor.BlockManager;
  const pfx = opts.pfx;

  const style = opts.defaultStyle
    ? `<style>
    .${pfx}-cont,
    .block {
      display: inline-block;
    }
  </style>`
    : '';

  if (opts.blocks.indexOf(paginationPageSize) >= 0) {
    bm.add(paginationPageSize, {
      label: `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" width="32" height="50"><!-- Font Awesome Free 5.15.3 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License) --><path d="M223.7 239l136-136c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9L319.9 256l96.4 96.4c9.4 9.4 9.4 24.6 0 33.9L393.7 409c-9.4 9.4-24.6 9.4-33.9 0l-136-136c-9.5-9.4-9.5-24.6-.1-34zm-192 34l136 136c9.4 9.4 24.6 9.4 33.9 0l22.6-22.6c9.4-9.4 9.4-24.6 0-33.9L127.9 256l96.4-96.4c9.4-9.4 9.4-24.6 0-33.9L201.7 103c-9.4-9.4-24.6-9.4-33.9 0l-136 136c-9.5 9.4-9.5 24.6-.1 34z"/></svg>
      <div class="gjs-block-label">${opts.label}</div>`,
      category: opts.category,
      content: `
      <div class="${pfx} flex-fill" data-gjs-type="paginationPageSize"  data-gjs="paginationPageSize" >
        <div class="${pfx}-inner-container d-flex" >
          <label class="p-2">Page Size:</label>
          <div class="page-item item-page-select-last dc-pagination-select" style="display: inline-block;">
            <select class="pageSizeSelect select page-link form-control">
              <option value="5">5</option>
              <option value="10" selected>10</option>
              <option value="20">20</option>
              <option value="30">30</option>
              <option value="40">40</option>
              <option value="50">50</option>
              <option value="100">100</option>
            </select>
          </div>
        </div>
      </div>
        ${style}
      `,
      render: ({ model, className }) => `
      <div class="${className}-label ${className}__drapcode-wrap">
      ${model.get('label')}
      </div>

      <span class="${className}__info no-doc">
        <a target="_blank" href="#" draggable="false">
          <i class="${className}__info-fa fa fa-info-circle" style="margin-left: 5px" title="Check how to use ${
        opts.label
      }?"></i>
        </a>
      </span>
    `,
    });
  }
}
